var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward24 = function SvgAward24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2a1 1 0 0 0 0 2h1v1.292a5 5 0 0 0 3.143 4.642l2.486.995a1 1 0 0 0 .742 0l2.486-.995A5 5 0 0 0 18 5.292V4h1a1 1 0 1 0 0-2H5Zm3 2v1.292a3 3 0 0 0 1.886 2.785L12 8.923l2.114-.846A3 3 0 0 0 16 5.292V4H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.951 11.691a1 1 0 0 0-1.902 0l-.898 2.764H7.245a1 1 0 0 0-.588 1.809l2.351 1.708-.898 2.764a1 1 0 0 0 1.539 1.118L12 20.146l2.351 1.708a1 1 0 0 0 1.539-1.118l-.898-2.764 2.351-1.708a1 1 0 0 0-.588-1.81H13.85l-.898-2.763Z",
    fill: "currentColor"
  })));
};
export default SvgAward24;